import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class RevenueForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      accounts: [],
      employees: [],
      contractors: [],
    },
    data: {
      amount: "",
      account_id: "",
      receipt_date: "",
      received_by_staff_id: "",
      remark: "",
      attachment: "",
      bank_ref_no: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.amount = edit.amount;
      data.account_id = edit.account_id;
      data.receipt_date = edit.receipt_date;
      data.received_by_staff_id = edit.received_by_staff_id;
      data.remark = edit.remark;
      data.bank_ref_no = edit.bank_ref_no;
    }

    await db
      .getAll(`dropdowns/staff?sectionId=1`)
      .then(({ data: { data } }) => (drp["employees"] = data));

    await db
      .getAll(`dropdowns/accounts`)
      .then(({ data: { data } }) => (drp["accounts"] = data));

    await db
      .getAll(`dropdowns/contractors`)
      .then(({ data: { data } }) => (drp["contractors"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    account_id: Joi.number().required(),
    receipt_date: Joi.string().required(),
    received_by_staff_id: Joi.number().required(),
    remark: Joi.string().max(1024),
    attachment: Joi.allow(null).allow(""),
    bank_ref_no: Joi.string().required(),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        revenue_sub_account_id: popUp?.sid,
        ...this.state.data,
      });

      await db
        .form("revenues", target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })

        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditRevenue : lbl.AddRevenue}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect("account_id", "حساب", drp["accounts"])}
            {this.renderSelect(
              "received_by_staff_id",
              "دریافت کننده",
              drp["employees"]
            )}
            {this.renderInput("receipt_date", "تاریخ دریافت", "date")}
            {this.renderInput("bank_ref_no", "ریفرنس نمبر")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default RevenueForm;
